import * as React from 'react';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';
import { getControlKey } from 'util/hotKeys';
import { RootStoreContext } from '../../App';

interface HotKeys {
    label: string;
    key: string;
    disabled?: boolean;
    shiftKey?: boolean;
}

const ShortCuts: React.FC = () => {
    const rootStore = useContext(RootStoreContext);
    const { t } = useTranslation(['settings']);
    const [ hotKeys, setHotKeys ] = useState<HotKeys[]>([]);
    const controlKey = getControlKey();

    useEffect(() => {
        const {
            EpochConfigMattersPageEnabled,
            EpochConfigTimersEnabled,
            EpochConfigReportsEnabled,
            EpochConfigManagementDashboard
        } = rootStore.appStore.features;
        const mgmtDashboardDisabled = !(EpochConfigManagementDashboard && rootStore.managementDashboardStore.roles.length > 0);

        setHotKeys([
            {label: 'home', key: '1'},
            {label: 'time_entries', key: '2'},
            {label: 'matters', key: '3', disabled: !EpochConfigMattersPageEnabled},
            {label: 'templates', key: '4'},
            {label: 'timers', key: '5', disabled: !EpochConfigTimersEnabled},
            {label: 'narratives', key: '6'},
            {label: 'project_time', key: '7', disabled: mgmtDashboardDisabled},
            {label: 'draft_time', key: '8', disabled: mgmtDashboardDisabled},
            {label: 'reports', key: '9', disabled: !EpochConfigReportsEnabled},
            {label: 'settings', key: '0'},
            {label: 'day', key: 'D'},
            {label: 'week', key: 'E'},
            {label: 'month', key: 'M'},
            {label: 'grid', key: 'G'},
            {label: 'today', key: 'P'},
            {label: 'start_timer', key: 'S', disabled: !EpochConfigTimersEnabled, shiftKey: true},
            {label: 'new_time_entry', key: 'L', shiftKey: true}
        ]);
    }, []);

    return (
        <Styled.ShortcutsContainer>
            <Styled.RowContainer tabIndex={0}>
                <Styled.ShortcutAction>{t('tab.user_information.tab.shortcuts.list.header.action')}</Styled.ShortcutAction>
                <Styled.KbdShortcut>{t('tab.user_information.tab.shortcuts.list.header.shortcut')}</Styled.KbdShortcut>
            </Styled.RowContainer>
            {controlKey &&
                <Styled.ShortcutsList>
                    {hotKeys.map((obj, ind) => !obj.disabled ?
                        <Styled.RowContainer
                            key={ind}
                            tabIndex={0}
                            aria-label={`
                                ${t(`tab.user_information.tab.shortcuts.list.actions.${obj.label}`)};
                                ${controlKey === 'CMD' ? 'Command' : controlKey}, ${obj.shiftKey ? 'Shift,' : ''} ${obj.key}
                            `}
                        >
                            <Styled.ShortcutAction>{t(`tab.user_information.tab.shortcuts.list.actions.${obj.label}`)}</Styled.ShortcutAction>
                            <Styled.KbdShortcut>
                                <Styled.Key>{controlKey}</Styled.Key>
                                <span>{` + `}</span>
                                {obj.shiftKey &&
                                    <>
                                        <Styled.Key>Shift</Styled.Key>
                                        <span>{` + `}</span>
                                    </>
                                }
                                <Styled.Key>{obj.key}</Styled.Key>
                            </Styled.KbdShortcut>
                        </Styled.RowContainer>
                    : 
                        null
                    )}
                    <Styled.RowContainer
                        tabIndex={0}
                        aria-label={`
                            ${t('tab.user_information.tab.shortcuts.list.actions.fab_container')};
                            Ctrl, Shift, A
                        `}
                    >
                        <Styled.ShortcutAction>{t('tab.user_information.tab.shortcuts.list.actions.fab_container')}</Styled.ShortcutAction>
                        <Styled.KbdShortcut>
                            <Styled.Key>Ctrl</Styled.Key>
                            <span>{` + `}</span>
                            <Styled.Key>Shift</Styled.Key>
                            <span>{` + `}</span>
                            <Styled.Key>A</Styled.Key>
                        </Styled.KbdShortcut>
                    </Styled.RowContainer>
                </Styled.ShortcutsList>
            }
        </Styled.ShortcutsContainer>
    );
}

export default ShortCuts;